export default __webpack_public_path__ + "static/media/MLBChaseBGSelectTeam.280baa03.png";